'use strict';

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Color = require("./Color");

var validators_1 = require("./validators");

function hexToRgb(hex, alpha) {
  var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  if (result) {
    return new Color(parseInt(result[1], 16), parseInt(result[2], 16), parseInt(result[3], 16), alpha);
  } else {
    throw new Error("".concat(hex, " is not a valid hex value."));
  }
}

var ColorScale = /*#__PURE__*/function () {
  function ColorScale(min, max, colorStops) {
    var alpha = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

    _classCallCheck(this, ColorScale);

    validators_1.validateMinMaxValues(min, max);
    validators_1.validateColorStops(colorStops);
    validators_1.validateAlphaValue(alpha);
    this.min = min;
    this.max = max;
    this.alpha = alpha;
    this.colorStops = colorStops.map(function (colorStop) {
      return hexToRgb(colorStop, alpha);
    });
  }

  _createClass(ColorScale, [{
    key: "getColor",
    value: function getColor(value) {
      var numOfColorStops = this.colorStops.length;
      if (value < this.min) return this.colorStops[0];
      if (value > this.max) return this.colorStops[numOfColorStops - 1];
      var range = this.max - this.min;
      var weight = (value - this.min) / range;
      var colorStopIndex = Math.max(Math.ceil(weight * (numOfColorStops - 1)), 1);
      var minColor = this.colorStops[colorStopIndex - 1];
      var maxColor = this.colorStops[colorStopIndex];
      weight = weight * (numOfColorStops - 1) - (colorStopIndex - 1);
      var r = Math.floor(weight * maxColor.r + (1 - weight) * minColor.r);
      var g = Math.floor(weight * maxColor.g + (1 - weight) * minColor.g);
      var b = Math.floor(weight * maxColor.b + (1 - weight) * minColor.b);
      return new Color(r, g, b, this.alpha);
    }
  }]);

  return ColorScale;
}();

module.exports = ColorScale;